export const camelCase = (data) => {
  const result = { ...data };
  Object.keys(data).forEach((key) => {
    let k = key;
    k = k.replace(/_./g, (m) => m[1].toUpperCase());
    if (k !== key) {
      console.log("key", key);
      result[k] = data[key];
    }
  });
  return result;
};

export const replaceKeys = (data, keys) => {
    const result = { ...data };
    Object.keys(keys).forEach((key) => {
      if(result[key]) {
        result[keys[key]] = data[key];
      }
    });
    return result;
  };
